var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMaestro(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "38px",
    height: "24px",
    viewBox: "0 0 38 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Maestro") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "WEEZ_PSP_UI_Icons",
    transform: "translate(-215.000000, -235.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Maestro",
    transform: "translate(215.000000, 235.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-2",
    stroke: "#CED0DA",
    fill: "#FFFFFF",
    x: 0.5,
    y: 0.5,
    width: 37,
    height: 23,
    rx: 4
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(6.000000, 4.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#7673C0",
    x: 9.46020262,
    y: 1.71087179,
    width: 7.012553,
    height: 12.5791222
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.90544408,8.00154395 C9.9028222,5.54649132 11.0316476,3.22666475 12.9664791,1.71087179 C9.68055047,-0.866714617 4.96182515,-0.491266866 2.12649649,2.57336046 C-0.708832164,5.63798778 -0.708832164,10.3628781 2.12649649,13.4275054 C4.96182515,16.4921327 9.68055047,16.8675805 12.9664791,14.289994 C11.0322631,12.7746823 9.90350669,10.4558168 9.90544408,8.00154395 L9.90544408,8.00154395 Z",
    id: "_Path_",
    fill: "#EB001B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9319104,8.00154395 C25.9311693,11.0634787 24.1794093,13.8563612 21.4202657,15.1945918 C18.6611221,16.5328224 15.378726,16.1815895 12.9664791,14.289994 C14.8998512,12.7733958 16.0286926,10.4548387 16.0286926,8.00043292 C16.0286926,5.54602718 14.8998512,3.22747001 12.9664791,1.71087179 C15.378706,-0.182083858 18.6620279,-0.534113204 21.4220052,0.804291968 C24.1819826,2.14269714 25.9341366,4.93656218 25.9341366,7.99932188 L25.9319104,8.00154395 Z",
    id: "Path",
    fill: "#00A1DF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M25.1697002,12.9679908 L25.1697002,12.7101296 L25.275232,12.7101296 L25.275232,12.6548737 L25.0080344,12.6548737 L25.0080344,12.7101296 L25.1135662,12.7101296 L25.1135662,12.9772001 L25.1697002,12.9679908 Z M25.6883778,12.9679908 L25.6883778,12.6456643 L25.6075449,12.6456643 L25.5132399,12.8758975 L25.4189349,12.6456643 L25.3358566,12.6456643 L25.3358566,12.9679908 L25.3942359,12.9679908 L25.3942359,12.726246 L25.4818049,12.9357582 L25.5424296,12.9357582 L25.6299985,12.726246 L25.6299985,12.9702931 L25.6883778,12.9679908 Z",
    id: "Shape",
    fill: "#00A1DF"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaestro);
export default __webpack_public_path__ + "static/media/Maestro.f66831e9.svg";
export { ForwardRef as ReactComponent };